// extracted by mini-css-extract-plugin
module.exports = {"d2xZ2":"Z2_d2xZ2__yaxY_","delta2maxDash":"Z2_delta2maxDash__SwUeB"};